import Vue from "vue";

import AccountLogin from "@Scripts/Components/Account/AccountLogin.vue";
import AccountLogout from "@Scripts/Components/Account/AccountLogout.vue";
import AccountRegister from "@Scripts/Components/Account/AccountRegister.vue";
import AccountEdit from "@Scripts/Components/Account/AccountEdit.vue";
import AccountEmailConfirmSend from "@Scripts/Components/Account/AccountEmailConfirmSend.vue";
import AccountPasswordRemind from "@Scripts/Components/Account/AccountPasswordRemind.vue";
import AccountPasswordReset from "@Scripts/Components/Account/AccountPasswordReset.vue";
import AccountExternalRegister from "@Scripts/Components/Account/AccountExternalRegister.vue";
import AccountSubscibeToast from "@Scripts/Components/Account/AccountSubscibeToast.vue";

import RegisterTeacher from "@Scripts/Components/RegisterTeacher/RegisterTeacher.vue";

import AgencySearchBox from "@Scripts/Components/AgencySearchBox/AgencySearchBox.vue";
import CookieToast from "@Scripts/Components/CookieToast/CookieToast.vue";
import DealerSearchBox from "@Scripts/Components/DealerSearchBox/DealerSearchBox.vue";
import DigitalDocumentSearchBox from "@Scripts/Components/DigitalDocumentSearchBox/DigitalDocumentSearchBox.vue";
import HeaderSearchBox from "@Scripts/Components/HeaderSearchBox/HeaderSearchBox.vue";
import HomePageSearchBox from "@Scripts/Components/HomePageSearchBox/HomePageSearchBox.vue";
import MagazineFilterBox from "@Scripts/Components/MagazineFilterBox/MagazineFilterBox.vue";
import NewsletterSubscribe from "@Scripts/Components/NewsletterSubscribe/NewsletterSubscribe.vue";
import NewsletterUnsubscribe from "@Scripts/Components/NewsletterUnsubscribe/NewsletterUnsubscribe.vue";
import ProductFilterBox from "@Scripts/Components/ProductFilterBox/ProductFilterBox.vue";
import ProductRequest from "@Scripts/Components/ProductRequest/ProductRequest.vue";
import InfoRequest from "@Scripts/Components/Support/InfoRequest/InfoRequest.vue";
import RequestEducationalLicence from "@Scripts/Components/Support/RequestEducationalLicence/RequestEducationalLicence.vue";

import Pagination from "@Scripts/Components/Pagination/Pagination.vue";

import ExpMenu from "@Scripts/Directives/ExpMenu/ExpMenu";

export default class AppConfig {
    public static AddComponents() {
        Vue.component("app-accountlogin", AccountLogin);
        Vue.component("app-accountlogout", AccountLogout);
        Vue.component("app-accountregister", AccountRegister);
        Vue.component("app-accountedit", AccountEdit);
        Vue.component("app-accountemailconfirmsend", AccountEmailConfirmSend);
        Vue.component("app-accountpasswordremind", AccountPasswordRemind);
        Vue.component("app-accountpasswordreset", AccountPasswordReset);
        Vue.component("app-accountexternalregister", AccountExternalRegister);
        Vue.component("app-accountsubscibetoast", AccountSubscibeToast);

        Vue.component("app-register-teacher", RegisterTeacher);

        Vue.component("app-agency-searchbox", AgencySearchBox);
        Vue.component("app-cookietoast", CookieToast);
        Vue.component("app-dealer-searchbox", DealerSearchBox);
        Vue.component("app-digitaldocument-searchbox", DigitalDocumentSearchBox);
        Vue.component("app-header-searchbox", HeaderSearchBox);
        Vue.component("app-homepage-searchbox", HomePageSearchBox);
        Vue.component("app-magazine-filterbox", MagazineFilterBox);
        Vue.component("app-newsletter-subscribe", NewsletterSubscribe);
        Vue.component("app-newsletter-unsubscribe", NewsletterUnsubscribe);
        Vue.component("app-product-filterbox", ProductFilterBox);
        Vue.component("app-product-request", ProductRequest);
        Vue.component("app-inforequest", InfoRequest);
        Vue.component("app-requesteducationallicence", RequestEducationalLicence);

        Vue.component("app-pagination", Pagination);
    }

    public static AddDirectives() {
        Vue.directive("exp-menu", ExpMenu);
    }
}